module.exports = __webpack_public_path__ + "img/vip1.9adc1100.png";